import { bindingTypes, functions } from '@easybutton/constants'
import ordinal from 'ordinal'
import * as inflected from 'inflected'

import { buildIndex } from './indexing'
import { getId } from './ids'
import { getInput } from './actions'

export const FUNCTIONS = [
  { label: 'Current Date / Time', name: functions.NOW },
  { label: 'UUID (v4)', name: functions.UUID },
  { label: 'Random Hex', name: functions.RANDOM_HEX },
  { label: 'Random String', name: functions.RANDOM_STRING },
  { label: 'Bcrypt', name: functions.BCRYPT, hasArgument: true },
  { label: 'Argon2', name: functions.ARGON2, hasArgument: true },
  { label: 'SHA-256', name: functions.SHA256, hasArgument: true },
]

export const FUNCTIONS_INDEX = buildIndex(FUNCTIONS, f => f.name)

export const buildInputBinding = input => {
  const { id: inputId, type: dataType } = input

  const binding = {
    ...buildBaseBinding(bindingTypes.INPUT),
    inputId,
    dataType,
  }

  return binding
}

export const buildColumnBinding = (parentBinding, column) => {
  const binding = {
    ...buildBaseBinding(bindingTypes.COLUMN),
    column,
    parentBinding,
  }

  return binding
}

export const buildInputColumnBinding = (input, column) => {
  const inputBinding = buildInputBinding(input)
  const columnBinding = buildColumnBinding(inputBinding, column)

  return columnBinding
}

export const buildOutputBinding = stepId => {
  const binding = {
    ...buildBaseBinding(bindingTypes.OUTPUT),
    stepId,
  }

  return binding
}

export const buildArrayItemBinding = (parentBinding, index) => {
  const binding = {
    ...buildBaseBinding(bindingTypes.ARRAY_ITEM),
    index,
    parentBinding,
  }

  return binding
}

export const buildFunctionBinding = (func, args) => {
  let binding = {
    ...buildBaseBinding(bindingTypes.FUNCTION),
    functionName: func.name,
    arguments: args,
  }

  return binding
}

export const buildBaseBinding = bindingType => ({
  id: getId(),
  type: 'binding',
  bindingType,
})

/* Get Labels */

export const getBindingLabel = (binding, action) => {
  switch (binding.bindingType) {
    case bindingTypes.INPUT:
      return getInputBindingLabel(binding, action)
    case bindingTypes.OUTPUT:
      return getOutputBindingLabel(binding, action)
    case bindingTypes.COLUMN:
      return getColumnBindingLabel(binding, action)
    case bindingTypes.FUNCTION:
      return getFunctionBindingLabel(binding, action)
    case bindingTypes.ARRAY_ITEM:
      return getArrayItemBindingLabel(binding, action)
    default:
      return 'Untitled'
  }
}

export const getInputBindingLabel = (binding, action) => {
  const { inputId, column } = binding
  const input = getInput(inputId, action)
  const { name } = input || {}

  let label = name

  if (column) {
    label = `${label} > ${column}`
  }

  return label
}

export const getOutputBindingLabel = (binding, action) => {
  const { stepId } = binding
  const step = action.details.steps.find(step => step.id === stepId)
  console.log('------->', step, stepId, binding, action.details.steps)
  const { table: tableName } = step

  return `New ${inflected.singularize(tableName)}`
}

export const getColumnBindingLabel = (binding, action) => {
  let { parentBinding, column } = binding

  let parentLabel = getBindingLabel(parentBinding, action)

  return `${parentLabel} > ${column}`
}

export const getArrayItemBindingLabel = (binding, action) => {
  let { parentBinding, index } = binding

  let parentLabel = getBindingLabel(parentBinding, action)

  return `${parentLabel} > ${ordinal(index + 1)} item`
}

const getFunctionBindingLabel = (binding, action) => {
  let args = (binding.arguments || []).map(arg => getBindingLabel(arg, action))

  let func = FUNCTIONS_INDEX[binding.functionName]

  let label = func.label

  if (func.hasArgument) {
    label = `${label}(${args[0]})`
  }

  return label
}
